import React, { useEffect, useState } from 'react';
import { postApi, getApi } from '../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [notifications, setNotifications] = useState({
    email: true, sms: true, trading: true, deposits: true, withdrawals: true, news: false,
  });
  const [showCurrentPwd, setShowCurrentPwd] = useState(false);
  const [showNewPwd, setShowNewPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);
  const [saving, setSaving] = useState(false);

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submittingPwd, setSubmittingPwd] = useState(false);
  const [userData, setUserData] = useState({});
  const [name, setName] = useState('');

  const handleSave = async () => {
    setSaving(true);
    try {
      const formData = new FormData();
      formData.append('name', name);

      const res = await postApi('profile/update', formData);
      if (res.data?.status === true || res.status === true) {
        toast.success(res.data?.message || 'Profile updated successfully');
        getProfile();
      } else {
        toast.error(res.data?.message || 'Failed to update profile');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => { getProfile(); }, []);


  const getProfile = async () => {
    try {
      const response = await getApi('profile');
      if (response.data?.status === true || response.status === true) {
        const user = response.data?.USER || response.USER;
        setUserData(user);
        setName(user?.name || '');
      }
    } catch (error) {
      console.error(error);

    } finally {
      // setLoading(false);
    }
  };

  const handlePasswordUpdate = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      toast.error('Please fill in all password fields');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('New password and confirm password do not match');
      return;
    }
    if (newPassword.length < 8) {
      toast.error('New password must be at least 8 characters');
      return;
    }

    setSubmittingPwd(true);
    try {
      const formData = new FormData();
      formData.append('old_password', oldPassword);
      formData.append('new_password', newPassword);

      const res = await postApi('updatePassword', formData);
      if (res.data?.status) {
        toast.success(res.data?.message || 'Password updated successfully');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        toast.error(res.data?.message || 'Failed to update password');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setSubmittingPwd(false);
    }
  };

  const tabs = [
    { id: 'profile', label: 'Profile', icon: 'bi-person' },
    { id: 'security', label: 'Security', icon: 'bi-shield-lock' },
  ];

  const toggleNotif = (key) => setNotifications(prev => ({ ...prev, [key]: !prev[key] }));

  return (
    <div className="page-wrapper">
      {/* Header */}
      <div className="page-header mb-4">
        <div className="section-label">Account</div>
        <h2 className="page-title">Settings</h2>
        <p className="page-subtitle">Manage your account preferences and security</p>
      </div>

      {/* Tabs */}
      <div className="p-tabs mb-4">
        {tabs.map(tab => (
          <button key={tab.id} className={`p-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}>
            <i className={`bi ${tab.icon}`}></i>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Profile Tab */}
      {activeTab === 'profile' && (
        <div className="row g-4">
          <div className="col-lg-4">
            <div className="p-card text-center">
              <div style={{ position: 'relative', display: 'inline-block', marginBottom: '1rem' }}>
                <div style={{ width: 100, height: 100, borderRadius: '50%', background: 'linear-gradient(135deg, rgba(0,255,149,0.3), rgba(0,212,255,0.2))', padding: 3, margin: '0 auto' }}>
                  <img
                    src={`https://ui-avatars.com/api/?name=${encodeURIComponent(userData?.name || 'User')}&background=071B12&color=00FF95&size=150&bold=true`}
                    alt="Avatar"
                    style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                  />
                </div>
                <button style={{ position: 'absolute', bottom: 0, right: 0, width: 28, height: 28, borderRadius: '50%', background: 'var(--page-accent)', border: 'none', color: '#071B12', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="bi bi-camera" style={{ fontSize: '0.75rem' }}></i>
                </button>
              </div>
              <h5 style={{ fontWeight: 700, marginBottom: 4 }}>{userData?.name || 'User'}</h5>
              <span className="s-pill active">{userData?.rank_name || 'Member'}</span>
              <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '0.75rem', marginBottom: 0 }}>
                Tap the camera icon to change your profile picture
              </p>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="p-card">
              <p className="section-label">Personal Information</p>
              <div className="row g-3">
                {[
                  { label: 'Full Name', type: 'text', placeholder: 'Enter your full name', value: name, onChange: (e) => setName(e.target.value), readOnly: false },
                  { label: 'Email Address', type: 'email', placeholder: 'Enter your email', value: userData?.email || '', readOnly: true },
                  { label: 'Phone Number', type: 'tel', placeholder: 'Enter your phone', value: userData?.mobile || '', readOnly: true },
                  { label: 'Wallet Address', type: 'text', placeholder: 'Your wallet', value: userData?.wallet_address || '', readOnly: true },
                ].map((field, i) => (
                  <div key={i} className="col-md-6">
                    <label className="p-label">{field.label}</label>
                    <input
                      type={field.type}
                      className="p-input form-control"
                      value={field.value}
                      onChange={field.onChange}
                      placeholder={field.placeholder}
                      readOnly={field.readOnly}
                      style={field.readOnly ? { backgroundColor: 'rgba(255, 255, 255, 0.05)', color: 'rgba(255, 255, 255, 0.6)', cursor: 'not-allowed' } : {}}
                    />
                  </div>
                ))}
              </div>
              <button className="btn btn-gradient mt-4" onClick={handleSave} disabled={saving} style={{ borderRadius: 12, padding: '0.7rem 2rem', fontWeight: 700 }}>
                {saving ? <><span className="spinner-border spinner-border-sm me-2"></span>Saving...</> : <><i className="bi bi-check2 me-2"></i>Save Changes</>}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Security Tab */}
      {activeTab === 'security' && (
        <div className="row g-4">
          <div className="col-lg-6">
            <div className="p-card">
              <p className="section-label">Authentication</p>
              <h5 style={{ fontWeight: 700, marginBottom: '1.5rem' }}>Change Password</h5>

              {[
                { label: 'Current Password', show: showCurrentPwd, toggle: () => setShowCurrentPwd(v => !v), value: oldPassword, onChange: (e) => setOldPassword(e.target.value) },
                { label: 'New Password', show: showNewPwd, toggle: () => setShowNewPwd(v => !v), value: newPassword, onChange: (e) => setNewPassword(e.target.value) },
                { label: 'Confirm New Password', show: showConfirmPwd, toggle: () => setShowConfirmPwd(v => !v), value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value) },
              ].map((field, i) => (
                <div key={i} className="mb-3">
                  <label className="p-label">{field.label}</label>
                  <div className="address-box" style={{ borderRadius: 12 }}>
                    <i className="bi bi-lock" style={{ color: 'rgba(255,255,255,0.3)', flexShrink: 0 }}></i>
                    <input
                      type={field.show ? 'text' : 'password'}
                      placeholder="••••••••••••"
                      value={field.value}
                      onChange={field.onChange}
                      style={{ background: 'transparent', border: 'none', color: 'white', flex: 1, outline: 'none', fontSize: '0.9rem' }}
                    />
                    <button type="button" onClick={field.toggle}
                      style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer', padding: 0 }}>
                      <i className={`bi ${field.show ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                    </button>
                  </div>
                </div>
              ))}

              <div style={{ marginTop: '0.5rem', marginBottom: '1.5rem' }}>
                {[
                  { check: newPassword.length >= 8, text: 'At least 8 characters' },
                  { check: /[A-Z]/.test(newPassword), text: 'One uppercase letter' },
                  { check: /[!@#$%^&*(),.?":{}|<>]/.test(newPassword), text: 'One special character' },
                ].map((req, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <i className={`bi ${req.check ? 'bi-check-circle-fill' : 'bi-circle'}`}
                      style={{ color: req.check ? 'var(--page-accent)' : 'rgba(255,255,255,0.2)', fontSize: '0.85rem' }}></i>
                    <span style={{ fontSize: '0.8rem', color: req.check ? 'rgba(255,255,255,0.8)' : 'var(--text-muted)' }}>{req.text}</span>
                  </div>
                ))}
              </div>

              <button
                className="btn btn-gradient w-100"
                onClick={handlePasswordUpdate}
                disabled={submittingPwd}
                style={{ borderRadius: 12, padding: '0.75rem', fontWeight: 700 }}
              >
                {submittingPwd ? <><span className="spinner-border spinner-border-sm me-2"></span>Updating...</> : <><i className="bi bi-shield-lock me-2"></i>Update Password</>}
              </button>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="p-card mb-4">
              <p className="section-label">Two-Factor Auth</p>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 style={{ fontWeight: 700, margin: 0 }}>2FA Protection</h6>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.82rem', margin: 0 }}>Add an extra layer of security</p>
                </div>
                <span className="s-pill pending">Disabled</span>
              </div>
              <div style={{ background: 'rgba(247,201,72,0.06)', borderRadius: 12, padding: '0.85rem 1rem', marginTop: '1rem', border: '1px solid rgba(247,201,72,0.2)' }}>
                <p style={{ margin: 0, fontSize: '0.82rem', color: 'var(--page-warning)' }}>
                  <i className="bi bi-info-circle me-2"></i>
                  Enable 2FA to secure your withdrawals and account access
                </p>
              </div>
              <button className="btn w-100 mt-3" style={{ background: 'rgba(0,255,149,0.08)', color: 'var(--page-accent)', border: '1px solid rgba(0,255,149,0.3)', borderRadius: 12, padding: '0.7rem', fontWeight: 700, fontFamily: 'Inter, sans-serif', cursor: 'pointer' }}>
                <i className="bi bi-phone me-2"></i>Enable 2FA
              </button>
            </div>

            <div className="p-card">
              <p className="section-label">Active Sessions</p>
              {[
                { device: 'Chrome — Windows', ip: '192.168.1.1', time: 'Now', active: true },
                { device: 'Safari — iPhone', ip: '10.0.0.5', time: '2h ago', active: false },
              ].map((s, i) => (
                <div key={i} className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <i className={`bi ${s.device.includes('Chrome') ? 'bi-laptop' : 'bi-phone'}`} style={{ fontSize: '1.2rem', color: 'rgba(255,255,255,0.5)' }}></i>
                    <div>
                      <div style={{ fontSize: '0.85rem', fontWeight: 600 }}>{s.device}</div>
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>{s.ip} · {s.time}</div>
                    </div>
                  </div>
                  {s.active ? (
                    <span className="s-pill active">Current</span>
                  ) : (
                    <button style={{ background: 'rgba(255,77,109,0.1)', color: 'var(--page-danger)', border: '1px solid rgba(255,77,109,0.2)', borderRadius: 8, padding: '3px 10px', fontSize: '0.75rem', cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
                      Revoke
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default Settings;